import React, {createContext, useContext} from 'react';

import {Transition} from './TransitionTypes';

export interface TransitionsContextValue {
  /** All transitions keyed by transition ID */
  transitionsById: Record<string, Transition>;
  /** Index mapping PTDV pairs to arrays of transition IDs for quick lookup */
  ptdvPairToTransitionIdIndex: Record<string, Array<string>>;
}

const TransitionsContext = createContext<TransitionsContextValue | null>(null);

export interface TransitionsContextProviderProps {
  children: React.ReactNode;
  value: TransitionsContextValue;
}

export function TransitionsContextProvider(props: TransitionsContextProviderProps): JSX.Element {
  return <TransitionsContext.Provider value={props.value}>{props.children}</TransitionsContext.Provider>;
}

export function useTransitionsContext(): TransitionsContextValue {
  const context = useContext(TransitionsContext);
  if (context == null) {
    throw new Error('useTransitionsContext must be used within a TransitionsContextProvider');
  }
  return context;
}
